module.exports = __webpack_public_path__ + "img/userA05.e63efe5e.jpg";